import React, { Component } from 'react'
import { levelOne, levelTwo, levelThree } from './text.js'
import ListItem from '../../components/ListItem/ListItem'
import Background from '../../components/Background/Background'
import Button from '../../components/Button/Button'
import Markdown from '../../components/Markdown/Markdown'
import Computedtext from '../../components/ComputedText/ComputedText'
import Gauge from '../../components/Gauge/Gauge'
import ConclusionTitle from '../../components/ConclusionTitle/ConclusionTitle'
import footer from './footer.jpg'
import ferringLogo from '../Home/ferring-logo.svg'

class Conclusion extends Component {
  constructor(props) {
    super(props)
    this.state = {
      selectedLevel: null,
    }
    this.handleClick = this.handleClick.bind(this)
  }

  componentDidMount() {
    if (this.props.totalScore <= 50) {
      this.setState({ selectedLevel: 1 })
    } else if (this.props.totalScore > 50 && this.props.totalScore <= 100) {
      this.setState({ selectedLevel: 2 })
    } else {
      this.setState({ selectedLevel: 3 })
    }
  }

  handleClick(e) {
    if (e.target.parentNode.id === 'book') {
      return this.setState({ selectedLevel: 1 })
    }
    if (e.target.parentNode.id === 'clock') {
      return this.setState({ selectedLevel: 2 })
    } else {
      return this.setState({ selectedLevel: 3 })
    }
  }

  render() {
    const { answers } = this.props
    console.log(this.state.selectedLevel)
    return (
      <Background color="#D0DCF0">
        <Computedtext
          sex={answers[1]}
          age={answers[2]}
          diaper={answers[6]}
          amount={answers[5]}
          timesPrWeek={answers[4]}
          when={answers[8]}
          problem={answers[3]}
          checkup={answers[7]}
        />
        <div className="pv4 bg-primary-color">
          <ConclusionTitle />
          <Gauge
            handleClick={this.handleClick}
            rotation={
              this.state.selectedLevel === 1
                ? -45
                : this.state.selectedLevel === 2 ? 0 : 45
            }
          />
          <div className="mb4 mt5 ph3 ph4-ns">
            <Markdown
              source={
                this.state.selectedLevel === 1
                  ? levelOne
                  : this.state.selectedLevel === 2 ? levelTwo : levelThree
              }
            />
          </div>
          <div className="mw3 mb2 center flex items-center justify-around">
            <span
              className={`h1 w1 bg-white br-100 ${
                this.state.selectedLevel === 1 ? 'o-100' : 'o-60'
              }`}
            />
            <span
              className={`h1 w1 bg-white br-100 ${
                this.state.selectedLevel === 2 ? 'o-100' : 'o-60'
              }`}
            />
            <span
              className={`h1 w1 bg-white br-100 ${
                this.state.selectedLevel === 3 ? 'o-100' : 'o-60'
              }`}
            />
          </div>
          <div className="flex flex-column items-center mw6 center">
            <Button pill negative>
              <a
                className="db tc w-100 no-underline white"
                href="http://www.torrhelenatten.no/"
                target="_blank"
                rel="noopener noreferrer"
              >
                Besøk tørrhelenatten.no
              </a>
            </Button>
          </div>
        </div>
        <section className="bg-primary-color-washed">
          <ListItem
            title="Ofte stilte spørsmål"
            description="Les svar på de mest vanlige spørsmålene."
            url="/faq"
          />
          <ListItem
            title="Finn din fastlege"
            description="Finn og kontakt din fastlege via helsenorge.no"
            url="https://helsenorge.no/kontakt-fastlegen/kom-i-kontakt"
            rel="noopener"
            target="_blank"
          />
          <ListItem
            title="Lurer du på noe mer?"
            description="Les nyttig artikler og se vidoer på tørrhelenatten.no"
            url="http://www.torrhelenatten.no/"
            rel="noopener"
            target="_blank"
          />
          <ListItem
            title="Ta testen på nytt"
            description="Nullstill svar og ta testen på nytt."
            url="/"
          />

          <img src={footer} alt="footer" />
          <section className="pv4 flex flex-column items-center">
            <img src={ferringLogo} alt="" />
          </section>
        </section>
      </Background>
    )
  }
}

export default Conclusion



// WEBPACK FOOTER //
// ./src/containers/Conclusion/Conclusion.js